import { isIsbn13 } from "../../../../common/utils/isbn.ts";
import { FormattedMessage } from "react-intl";
import { ElementType } from "react";

export default function IsbnInfo({
  identifier,
  specifyPrint = true,
  tagName,
}: {
  identifier: string | null;
  specifyPrint?: boolean;
  tagName?: ElementType;
}) {
  if (!identifier) {
    return null;
  }
  if (isIsbn13(identifier)) {
    if (specifyPrint) {
      return (
        <FormattedMessage
          tagName={tagName}
          defaultMessage={"Print ISBN: {isbn}"}
          values={{ isbn: identifier }}
        />
      );
    } else {
      return (
        <FormattedMessage
          tagName={tagName}
          defaultMessage={"ISBN: {isbn}"}
          values={{ isbn: identifier }}
        />
      );
    }
  }
  return (
    <FormattedMessage
      tagName={tagName}
      defaultMessage="Identifier: {isbn}"
      values={{ isbn: identifier }}
    />
  );
}
